module.exports = __webpack_public_path__ + "img/pyra-and-mythra-min.dcc39ed8.png";